import React from "react";
import SearchInput from "./searchInput";
import { Link } from "gatsby";


type NavProps = {
    className?: string;
    showNav?: boolean;
    isMenuOpen?: boolean;
    setIsOpen: (isOpen: boolean) => void;
    categories?: { url: string, title: string }[];
};

export const Nav: React.FC<NavProps> = ({
    className = "",
    showNav = true,
    isMenuOpen = false,
    setIsOpen,
    categories,
}) => {
    const onClick = () => setIsOpen(false);

    return (
        <>
            <nav className={`text-base-r lg:text-base`}>
                <div
                    className={`${showNav ? "max-h-[400px]" : "max-h-0"} transition-all duration-200 ease-in-out
                    ${className} overflow-auto`}
                >
                    <div className="w-full h-4 md:hidden -translate-y-5 bg-transparent -z-10 shadow-xl md:shadow-none overflow-visible"></div>
                    <div className="px-[10px] pb-1 w-full">

                        <SearchInput onClick={onClick} className="-mt-2 mb-2 lg:hidden w-full" />
                        <ul className="w-full pl-2">
                            {categories?.slice(0, 3).map((item, index) => {
                                return (
                                    <NavItem
                                        key={index}
                                        name={item.title}
                                        link={item.url}
                                        onClick={onClick}
                                    />
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </nav>
            {/* </FadeInOut> */}
        </>
    );
};

type NavItemProps = {
    name: string;
    link: string;
    onClick: () => void;
};

const NavItem: React.FC<NavItemProps> = ({
    onClick,
    name,
    link,
}) => {
    return (
        <li className={`text-base-16 text-dark tracking-[-0.3px] py-3 border-t border-stroke-color`} onClick={onClick}>
            <Link to={link}>
                <div
                    dangerouslySetInnerHTML={{ __html: name }}>
                </div>
            </Link>
        </li>
    );
};

export default Nav;
